import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=3370c59d&scoped=true&lang=pug&"
import script from "./contact-form.vue?vue&type=script&lang=ts&"
export * from "./contact-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3370c59d",
  null
  
)

export default component.exports